import { HeadingItem } from '@atlaskit/side-navigation';
import styled from 'styled-components';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const StyledHeadingItem = styled(HeadingItem)({
  textTransform: 'none',
});
